import React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import * as styles from "./FeaturedCycle.css"
import ContributorsCycle from "../contributors-cycle"
import { shuffleArray } from "../../utils"
import {
  Section,
} from "../ui"

export interface FeaturedCycleProps {
  id: string
  title: string
  source: string
  desktopRight: boolean
}

export default function FeaturedCycle(props: FeaturedCycleProps) {
  
  const allOf = useStaticQuery(
    graphql`
      query {
        allMusic(filter: {featured: { eq: true }}) {
          nodes {
            ...PerformerContent
          }
        }
        allArtist(filter: {featured: { eq: true }}) {
          nodes {
            ...PerformerContent
          }
        }
        allFood(filter: {featured: { eq: true }}) {
          nodes {
            ...FoodContent
          }
        }
      }
    `
  )

  const artists = allOf.allArtist.nodes
  const music = allOf.allMusic.nodes
  const food = allOf.allFood.nodes
  const artists_and_music = artists.concat(music)

  const unshuffledFeatures = props.source == "food" ? food : artists_and_music
  const features = shuffleArray(unshuffledFeatures)

  return (
    <Section className={styles.featuredCycle}>
      <ContributorsCycle title={props.title} id={props.id} features={features} />
    </Section>
  )
}

export const query = graphql`
  fragment FeaturedCycleContent on FeaturedCycle {
    id
    source
    title
    desktopRight
  }
`